module.exports = __webpack_public_path__ + "static/media/pulse.4b56147c.gif";